import React, {useState} from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import {PersonIcon, SignNowIcon} from '../../Icon';
import {getKey} from '../../GenerateKey';
import Chip from '@material-ui/core/Chip';
import SignerInfoPopup from './signerInfoPopup';
import JDFSigner from '../Constants/JDFSigner.json';
import {FormattedMessage} from 'react-intl';

function getSteps(signersList) {
    const OrderOne = [];
    const OrderTwo = [];
    const OrderThree = [];
    const OrderFour = [];
    const OrderFive = [];
    const OrderSix = [];
    signersList.map(signer => {
        if (signer.signingOrder === '1') {
            OrderOne.push(signer)
        } else if (signer.signingOrder === '2') {
            OrderTwo.push(signer)
        } else if (signer.signingOrder === '3') {
            OrderThree.push(signer)
        } else if (signer.signingOrder === '4') {
            OrderFour.push(signer)
        } else if (signer.signingOrder === '5') {
            OrderFive.push(signer)
        } else if (signer.signerRole === JDFSigner.role) {
            OrderSix.push(signer)
        }
    })
    return [OrderOne, OrderTwo, OrderThree, OrderFour, OrderFive, OrderSix];
}

const statusColours = {
    created: '#666666', //grey
    sent: '#FFB000', //yellow-sea
    delivered: '#FF8C00', //yellow
    declined: '#c21020', //red
    completed: '#367c2b', //green
    autoresponded: '#337dc1' //dark-blue // Signer Status autoresponded means email is Undeliverable/Bounced beacuse of some reason.
}


function getSignerChip(envelopeStatus, signer, envelopeId) {
    const [hideSignerInfoPopup, setHideSignerInfoPopup] = useState(false);
    const showSignNowIcon = (signer.status === 'sent' || signer.status === 'delivered') && envelopeStatus !== 'completed' && envelopeStatus !== 'declined' && signer.signingOption === 'Sign now';
    return (
        <span key={'signerstatus-' + getKey() + getKey()}>
            <Chip className="mb-1" icon={showSignNowIcon ? <SignNowIcon envelopeId={envelopeId} signer={signer}/> : null}
                label=
                    {
                        <strong data-sl="mask">
                            {JDFSigner.role === signer.signerRole ? <FormattedMessage id={'labels.JDF_SIGNER'} /> : signer.signerName}
                        </strong>
                    }
                onClick={() => setHideSignerInfoPopup(!hideSignerInfoPopup)}
                size="medium" style={{color: '#ffffff', 'backgroundColor': statusColours[signer.status]}}
            />
            <br/>
            <SignerInfoPopup
                envelopeId={envelopeId}
                isHidden={hideSignerInfoPopup}
                setHideSignerInfoPopup={setHideSignerInfoPopup}
                showSignNowIcon={showSignNowIcon}
                signerInfo={signer}
                statusColor={statusColours[signer.status]}
            />
        </span>
    )
}

export default function StatusDashboardStepper({envelopeStatus, signersList, bgColor, envelopeId}) {
    const steps = getSteps(signersList);

    return (
        <Stepper alternativeLabel className="mw-100" style={{'backgroundColor': bgColor}}>
            {steps.filter(step => step.length > 0).map((signers) => (
                <Step active={true} key={'sign-' + getKey() + getKey()}>
                    <StepLabel icon={<PersonIcon/>}>
                        {signers.map(signer => getSignerChip(envelopeStatus, signer, envelopeId))}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}
